/**
 * Impact v1 — count-up stats when section enters viewport
 */
(function () {
  'use strict';

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function parseStat(str) {
    var raw = String(str || '').trim();
    if (!raw) return null;
    var m = raw.match(/^([^0-9]*)([0-9][0-9,]*(?:\.[0-9]+)?)(.*)$/);
    if (!m) return null;
    var numStr = m[2];
    return {
      prefix: m[1] || '',
      value: parseFloat(numStr.replace(/,/g, '')),
      suffix: m[3] || '',
      decimals: (numStr.split('.')[1] || '').length,
      useCommas: numStr.indexOf(',') !== -1,
      original: raw
    };
  }

  function formatValue(parsed, current) {
    var n = parsed.decimals > 0 ? current.toFixed(parsed.decimals) : String(Math.round(current));
    if (parsed.useCommas) {
      var parts = n.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      n = parts.join('.');
    }
    return parsed.prefix + n + parsed.suffix;
  }

  function animateEl(el, duration) {
    var target = el.getAttribute('data-impact-count');
    if (!target) return;
    var parsed = parseStat(target);
    if (!parsed || isNaN(parsed.value)) {
      el.textContent = target;
      return;
    }

    if (prefersReducedMotion() || duration <= 0) {
      el.textContent = parsed.original;
      return;
    }

    var start = null;
    function frame(ts) {
      if (start === null) start = ts;
      var t = Math.min(1, (ts - start) / duration);
      var eased = 1 - Math.pow(1 - t, 3);
      el.textContent = formatValue(parsed, parsed.value * eased);
      if (t < 1) {
        requestAnimationFrame(frame);
      } else {
        el.textContent = parsed.original;
      }
    }
    el.textContent = formatValue(parsed, 0);
    requestAnimationFrame(frame);
  }

  function initSection(root) {
    if (!root || root.getAttribute('data-impact-ready') === '1') return;
    if (root.getAttribute('data-impact-count-up') !== 'true') return;

    var duration = parseInt(root.getAttribute('data-impact-duration') || '1800', 10);
    var nodes = root.querySelectorAll('[data-impact-count]');
    if (!nodes.length) return;

    root.setAttribute('data-impact-ready', '1');

    function run() {
      nodes.forEach(function (el) {
        animateEl(el, duration);
      });
    }

    if (!('IntersectionObserver' in window)) {
      run();
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            run();
            io.disconnect();
          }
        });
      },
      { threshold: 0.3, rootMargin: '0px 0px -6% 0px' }
    );
    io.observe(root);
  }

  function initAll() {
    document.querySelectorAll('[data-impact-v1]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target && event.target.querySelector
      ? event.target.querySelector('[data-impact-v1]')
      : null;
    if (root) {
      root.removeAttribute('data-impact-ready');
      initSection(root);
    }
  });
})();
